import { render } from "./DocMarkdown.vue?vue&type=template&id=e1dd504a"
import script from "./DocMarkdown.vue?vue&type=script&lang=js"
export * from "./DocMarkdown.vue?vue&type=script&lang=js"

import "./DocMarkdown.vue?vue&type=style&index=0&id=e1dd504a&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__